/* eslint-disable import/prefer-default-export */
export const DATA_LAYER_PUSH = 'DATA_LAYER_PUSH';
